import React, { useCallback, useEffect, useState } from 'react';

import { Container, Grid, Typography } from '@material-ui/core';

import { discountsDefaultCriteria } from '../../blocs/discounts.bloc';
import DiscountsFilter from '../../components/discounts/DiscountsFilter';
import DiscountsTable from '../../components/discounts/DiscountsTable';
import { ACTIONS } from '../../constants/logs';
import LogService from '../../services/log.service';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [discounts, setDiscounts] = useState([]);
  const [total, setTotal] = useState([]);
  const [searchCriteria, setSearchCriteria] = useState(discountsDefaultCriteria);

  const blocRef = useBlocRef('discountsBloc');

  useEffect(() => {
    new LogService().create({
      action: ACTIONS.DISCOUNTS_VIEWED,
      details: {
        Page: 1,
      },
    });
  }, []);

  useEffect(() => {
    const searchCriteriaSub = blocRef.current.searchCriteria$.subscribe(setSearchCriteria);
    const discountsSub = blocRef.current.discounts$.subscribe(setDiscounts);
    const totalSub = blocRef.current.total$.subscribe(setTotal);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
      searchCriteriaSub.unsubscribe();
      discountsSub.unsubscribe();
      totalSub.unsubscribe();
    };
  }, [blocRef]);

  const handleCriteriaChange = useCallback(
    (updatedCriteria) => {
      blocRef.current.updateSearchCriteria(updatedCriteria);
    },
    [blocRef]
  );

  const handleFilterChange = useCallback(
    (updatedCriteria) => {
      blocRef.current.updateSearchCriteria({ ...updatedCriteria, page: 0 });
    },
    [blocRef]
  );

  const handleAddDiscount = useCallback(() => {
    blocRef.current.openAddDiscountPopup();
  }, [blocRef]);

  const handleEditDiscount = useCallback(
    (id) => {
      blocRef.current.openEditDiscountPopup(id);
    },
    [blocRef]
  );

  const handleRemoveDiscount = useCallback(
    (id) => {
      blocRef.current.openRemoveDiscountPopup(id);
    },
    [blocRef]
  );

  return (
    <Grid container style={{ padding: '2rem' }} component={Container}>
      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <Typography variant="h4" align="left" className="page-haeder mb-1">
          Discount List
        </Typography>
      </Grid>

      <Grid item xs={12} style={{ paddingLeft: '8px' }}>
        <DiscountsFilter onCriteriaChange={handleFilterChange} onAddDiscount={handleAddDiscount} />
      </Grid>

      <Grid item xs={12}>
        <DiscountsTable
          discounts={discounts}
          total={total}
          searchCriteria={searchCriteria}
          onCriteriaChange={handleCriteriaChange}
          onDeleteClick={handleRemoveDiscount}
          onEditClick={handleEditDiscount}
        />
      </Grid>
    </Grid>
  );
};
